import { gql } from "@apollo/client";

export const getPayoutStatsLensList = gql`
    query payoutStatsLensList($input: PayoutStatsInput!) {
        payoutStats(input: $input) {
            lensList {
                lenses {
                    unlockableId
                    totalEarningsMilliUsd
                    totalPayoutCount
                    totalSubscriptionCount
                    totalSubscriberUniqueUsers
                    lensPlusScore
                    lensPlusSignups {
                        total
                        paid
                        settled
                        estimated
                    }
                    firstPayoutAt
                    lastPayoutAt
                    lens {
                        id
                        name
                        iconUrl
                        status
                        visibility
                        organizationId
                        lensCreatorPayoutEligibility
                        lensAccountId {
                            lensSpaceId
                        }
                        distributionsList {
                            destinationType
                            destinationId
                            status
                        }
                        updatedAt {
                            seconds
                            nanos
                        }
                        qrCode {
                            deeplink
                        }
                    }
                }
                totalLensCount
                cursor
            }
        }
    }
`;
